<template>
    <div class="fSize">
        <p class="content" v-show="!emptyShow" v-html="content"></p>
        <van-empty v-show="emptyShow" :description="content"/>
    </div>
</template>
<script>
    //引用vant组件，用什么引什么
    import {gainContent} from '@/api/common';
    import {Toast, Empty} from 'vant';

    export default {
        components: {
            [Toast.name]: Toast,
            [Empty.name]: Empty
        },
        data() {
            return {
                //-------
                content: "数据请求中...",
                emptyShow: true
            }
        },
        created() {
            const that = this;
            //---控制头尾显示与隐藏----
            //that.$emit('footer', true);
            //this.$emit('header', false);
            that.gainInfo();
        },
        mounted() {
            window.history.pushState(null, null, "#");
            window.addEventListener(
                "popstate",
                function (e) {
                    WeixinJSBridge.call("closeWindow");
                },
                false
            );
        },
        methods: {
            gainInfo: function (code) {
                const that = this;
                gainContent({name: "physical_guide"}).then(resp => {
                    if (resp.code === 200) {
                        that.emptyShow = false;
                        let value = resp.data.value;
                        value = "&#12288;&#12288;" + value;
                        value = value.replace(/\\r\\n/g, "<br/>&#12288;&#12288;");
                        that.content = value;
                        that.emptyShow = !that.content;
                    } else {
                        that.content = resp.msg;
                    }
                }).catch(err => {
                    console.log(err);
                })
            }
        }
    }
</script>
<style scoped>
    .content {
        margin: inherit;
        box-sizing: border-box;
        width: 100%;
        padding: 0.2rem 0.32rem;
        overflow: hidden;
        color: #323233;
        font-size: 0.28rem;
        line-height: 0.6rem;
        background-color: #fff;
    }
</style>
